import { render } from "./general.vue?vue&type=template&id=720f8ee2&ts=true"
import script from "./general.ts?vue&type=script&lang=ts&external"
export * from "./general.ts?vue&type=script&lang=ts&external"

import "./general.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__